export default __webpack_public_path__ + "static/media/border-top.e74f42e0.svg";